import {ReelsConfig} from '@gongxigames/framework/slot';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';

export const gameReelsConfig: ReelsConfig = {
    reelsSpeedLevels: [],
    blur: 4,
    symbolsSprites: {
        0: 'wild_x3',
        1: 'pic_a_x3',
        2: 'pic_b_x3',
        3: 'pic_c_x3',
        4: 'a_x3',
        5: 'k_x3',
        6: 'q_x3',
        7: 'j_x3',
        8: 't_x3',
        9: 'n_x3',
        10: 'scatter_x3_en',
        11: 'wild_activator_x3',
        12: 'pic_a_double_x3',
        13: 'pic_b_double_x3',
        14: 'pic_c_double_x3',
        15: 'a_double_x3',
        16: 'k_double_x3',
        17: 'q_double_x3',
        18: 'j_double_x3',
        19: 't_double_x3',
        20: 'n_double_x3',
        21: 'rubycoin_x3'
    },
    defaultSymbolsOrder: [
        WolfHaven.N,
        WolfHaven.T,
        WolfHaven.J,
        WolfHaven.Q,
        WolfHaven.K,
        WolfHaven.A,
        WolfHaven.PICc,
        WolfHaven.PICb,
        WolfHaven.PICa,
        WolfHaven.Scatter,
        WolfHaven.Wild,
        WolfHaven.Activator,
        WolfHaven.Ruby
    ],
    oversizeSymbols: [
        WolfHaven.Scatter,
        WolfHaven.Wild,
        WolfHaven.Activator,
        WolfHaven.Ruby
    ],
    symbolsWithHitAnimation: [
        WolfHaven.Activator,
        WolfHaven.Ruby
    ],
    scatterIndex: WolfHaven.Scatter,
    rubySymbol: WolfHaven.Ruby
};
